function dasherize(str) {
    if (!str)
        return '';
    return str.replace(/[A-Z](?:(?=[^A-Z])|[A-Z]*(?=[A-Z][^A-Z]|$))/g, function (s, i) {
        return (i > 0 ? '-' : '') + s.toLowerCase();
    });
}

export { dasherize };
